import { Moment } from 'moment';
import { HandshakeStatus } from '../enums/HandshakeStatus';
import { TlsServerVersion } from '../enums/TlsServerVersion';
import { Handshake } from './Handshake';

export class TlsHandshake extends Handshake {
  constructor(
    id: number,
    initiatorIp: string,
    targetIp: string,
    initiatorPort: number | null,
    targetPort: number | null,
    timestamp: Moment | null,
    status: HandshakeStatus,
    private readonly serverName: string | null,
    private readonly selectedCiphersuiteName: string,
    private readonly serverChosenVersion: TlsServerVersion | null
  ) {
    super(id, initiatorIp, targetIp, initiatorPort, targetPort, timestamp, status);
  }

  getServerName() {
    return this.serverName;
  }

  getSelectedCiphersuiteName() {
    return this.selectedCiphersuiteName;
  }

  getServerChosenVersion() {
    return this.serverChosenVersion;
  }
}
